import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { Globals } from "../../common/global";

@Component({
  selector: "app-waiver",
  templateUrl: "./waiver.component.html",
  styleUrls: ["./waiver.component.css"],
})
export class WaiverComponent implements OnInit {
  frekisData: any;
  sharekayakData: any;
  hasDefaultFrekis = false;
  hasDefaultSharekayak = false;
  userId = "";
  constructor(
    private toastr: ToastrService,
    private apiCallingService: ApiCallingService,
    public Globals: Globals
  ) {
    this.userId = this.Globals.user._id;
  }

  ngOnInit(): void {
    this.getTerms();
  }
  getTerms() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.WAIVER.GET_WAIVER + "?user_id=" + this.userId
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          var data = res.data;

          if (data.waiverTerm) {
            this.sharekayakData = data.waiverTerm;
            this.hasDefaultSharekayak = false;
          } else {
            this.sharekayakData = data.defaultWaiverTerm;
            this.hasDefaultSharekayak = true;
          }

          if (data.waiverTerm) {
            this.frekisData = data.waiverTerm;
            this.hasDefaultFrekis = false;
          } else {
            this.frekisData = data.defaultWaiverTerm;
            this.hasDefaultFrekis = true;
          }
        }
      });
  }

  updateTerms(data: any) {
    if (!this.hasDefaultFrekis) {
      const body = new HttpParams()
        .set("terms", data.content)
        .set("brand_name", this.frekisData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(
          body,
          "PUT",
          ConfigApi.URLS.WAIVER.UPDATE + "/" + this.frekisData._id
        )
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    } else {
      const body = new HttpParams()
        .set("user_id", this.userId)
        .set("terms", data.content)
        .set("brand_name", this.frekisData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(body, "POST", ConfigApi.URLS.WAIVER.ADD)
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    }
  }
  updateTerms2(data: any) {
    if (!this.hasDefaultSharekayak) {
      const body = new HttpParams()
        .set("terms", data.content)
        .set("brand_name", this.sharekayakData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(
          body,
          "PUT",
          ConfigApi.URLS.WAIVER.UPDATE + "/" + this.sharekayakData._id
        )
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    } else {
      const body = new HttpParams()
        .set("user_id", this.userId)
        .set("terms", data.content)
        .set("brand_name", this.sharekayakData.brand_name)
        .set("title", data.titlename);
      this.apiCallingService
        .callAPI(body, "POST", ConfigApi.URLS.WAIVER.ADD)
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Waiver updated successfully");
            this.getTerms();
          }
        });
    }
  }
}
